<template>
  <transition name="fade">
    <div v-if="visible" :class="classes" :style="styles">
      <div :class="mainClasses">
        <span :class="dotClasses"></span>
        <div :class="textClasses"><slot></slot></div>
      </div>
    </div>
  </transition>
</template>
<script>
import Emitter from '../../mixins/emitter'
import ScrollbarMixins from '../../mixins/mixins-scrollbar'

const prefixCls = 'loading'

export default {
  name: 'Loading',
  mixins: [Emitter, ScrollbarMixins],
  props: {
    size: {
      type: String,
      validator(value) {
        return ['sm', 'lg'].includes(value)
      }
    },
    fix: {
      type: Boolean,
      default: false
    },
    fullscreen: {
      type: Boolean,
      default: false
    },
    fullscreenVisible: { // 只在fullscreen设置为true的时候有效
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showText: false
    }
  },
  computed: {
    classes() {
      return [
        `${prefixCls}`,
        {
          [`${prefixCls}-${this.size}`]: !!this.size,
          [`${prefixCls}-fix`]: this.fix,
          [`${prefixCls}-show-text`]: this.showText,
          [`${prefixCls}-fullscreen`]: this.fullscreen
        }
      ]
    },
    styles() {
      let styles = {}
      if (this.fullscreen) {
        styles.position = 'fixed'
      }
      return styles
    },
    mainClasses() {
      return `${prefixCls}-main`
    },
    dotClasses() {
      return `${prefixCls}-dot`
    },
    textClasses() {
      return `${prefixCls}-text`
    },
    visible() {
      if (this.fullscreen) {
        return this.fullscreenVisible
      } else {
        return true
      }
    }
  },
  watch: {
    fullscreenVisible (val) {
      if (val) {
        this.addScrollEffect()
      } else {
        this.removeScrollEffect()
      }
    }
  },
  mounted() {
    this.showText = this.$slots.default !== undefined
  }
}
</script>



// WEBPACK FOOTER //
// loading.vue?e6eb5e24